import { SelectItems } from 'Types/selectItems'

export enum ActStatuses {
	ON_PARTNER_SIGNING = 'on_partner_signing',
	ON_DS_SIGNING = 'on_ds_signing',
	SIGNED = 'signed',
	CANCELED_BY_PARTNER = 'canceled_by_partner',
	CANCELED_BY_DS = 'canceled_by_ds',
	DELETED = 'deleted',
	PAID = 'paid',
	REFUND = 'refund',
	ANNUL = 'annul',
	ON_ANNUL_DS = 'on_annul_ds',
}
export const GenerateProtocolStatuses = new Set([
	ActStatuses.ON_DS_SIGNING,
	ActStatuses.SIGNED,
	ActStatuses.CANCELED_BY_DS,
	ActStatuses.PAID,
	ActStatuses.REFUND,
])

export const numberActs = 10000

export const ActsSortedFields = {
	status_update: 'status_updated_at',
	period: 'period',
}

export const ACT_SORT_OPTIONS: SelectItems = [
	{
		id: 'period',
		name: 'По периоду',
	},
	{
		id: 'status_updated_at',
		name: 'По дате обновления',
	},
]
